import { useState, useContext, useEffect, } from 'react';
import { Switch, } from '@mui/material';
import { ColorModeContext, } from '../../hoc/context/ColorModeContext';
import { useAuth, useFirestore, useDocument, } from '../../hooks';
import { useTheme, } from '@mui/material/styles';

export default function ColorModeSwitches() {
    const [checked, setChecked] = useState(false);
    const { user, } = useAuth();
    const { updateDocument, response, } = useFirestore('userSettings');
    const { document, } = useDocument({
        col: 'userSettings',
        id: user.uid,
    });
    const colorMode = useContext(ColorModeContext);
    const theme = useTheme();

    const currentMode = document && document.mode;

    const handleChange = () => {
        updateDocument(user.uid, { mode: currentMode === 'light' ? 'dark' : 'light' });
    };

    useEffect(() => {
        if (currentMode !== null && currentMode !== theme.palette.mode) {
            colorMode.toggleColorMode();
        }
        setChecked(currentMode === 'light' ? false : true);
    }, [currentMode]);

    return (
        <Switch
            color='secondary'
            checked={checked}
            disabled={response.isPending}
            onChange={handleChange}
            inputProps={{ 'aria-label': 'controlled', }}
            sx={{
                '& .MuiSwitch-track': {
                    bgcolor: 'background.default',
                },
            }}
        />
    );
};
